<header
    class="transition-transform duration-300 ease-in md:bg-primary-50 md:dark:bg-primary-600 bg-primary md:translate-y-0 border-primary-200/50"
    [class.-translate-y-13]="centeredTitle() && !showCenteredTitle()"
    [class.translate-y-0]="centeredTitle() && showCenteredTitle()"
    [class.md:border-b-2]="scrollPositionY() > 0">
    <div class="hidden bg-primary text-white md:block">
        <div class="container">
            <ng-content select="[secondaryHeaderContent]"></ng-content>
        </div>
    </div>
    <ng-content select="[centeredTitle]"></ng-content>
    <div class="container text-white md:text-primary py-2">
        <ng-content select="[primaryHeaderContent]"></ng-content>
    </div>
    <ng-content></ng-content>
</header>
